import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import moment from "moment";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Select,
  message,
  Space,
  Tooltip,
  Typography,
} from "antd";
import {
  DownloadOutlined,
  LoadingOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
import {getDefaultStateParams} from "./TransactionsUtils";
import {convertDateFormat} from "./TransactionsDownloadUtils.js";
import { getBuffer, getMimeType, saveFile } from "./TransactionsDownloadUtils";
import useTransactionsDownload from "./useTransactionsDownload";
import { useMessageUtils } from "../../utils/useMessageUtils.js";

export default function TransactionsDownloadSection(props) {
  const filters = props.propData;

  const { isLoading, batchSize, bufferSize, fetchFile, fetchStatistics } =
    useTransactionsDownload();

  const { queryParams, fileDownloadParams } = getDefaultStateParams();
  const { showMessage, closeMessage, contextHolder } = useMessageUtils();

  const initialState = {
    dateFrom: queryParams.defaultDateFrom.unix(),
    dateTo: queryParams.defaultDateTo.unix(),
    serviceName: "transactions",
    fileExtension: fileDownloadParams.defaultFileExtension,
  };

  const [currentState, setCurrentState] = useState(initialState);
  const [isFileSaving, setIsFileSaving] = useState(false);
  const disabledDate = (current) => current > moment();


  const onDateChange = (date) => {
    const dateFrom = date.startOf("month").unix();
    const dateTo = date.endOf("month").unix();

    setCurrentState({ ...currentState, dateFrom, dateTo });
  };

  const onServiceChange = (selectedService) => {
    setCurrentState({ ...currentState, serviceName: selectedService });
  };

  const onFileExtensionChange = (selectedFileExtension) => {
    setCurrentState({ ...currentState, fileExtension: selectedFileExtension });
  };

  const DownloadButtonIcon = () => {
    return (isLoading || isFileSaving) ? (
      <LoadingOutlined spin />
    ) : (
      <CloudDownloadOutlined style={{ fontSize: "20px" }} />
    );
  };

  const DownloadButtonLabel = () => {
    if (!isLoading) return "Download .xlsx";

    let estimatedSize = (batchSize / bufferSize) * 100;
    if (!isFinite(estimatedSize)) estimatedSize = 0;
    estimatedSize = `${estimatedSize.toFixed(1)}%`;

    return estimatedSize;
  };

  const onDownloadButtonClick = async (event) => {
    showMessage('loading', 'Report is preparing..', 0);

    const { dateFrom, dateTo, serviceName, fileExtension } = currentState;
    const rawData = await fetchFile({ params: filters });
    const statistics = await fetchStatistics({ params: {
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
      },
    });
    try {
      setIsFileSaving(true);
      const buffer = await getBuffer(serviceName, rawData, fileExtension, statistics);
      const mimeType = getMimeType(fileExtension);
      const filename = `${serviceName}_${convertDateFormat(filters.dateFrom*1000)}_${convertDateFormat(filters.dateTo*1000)}.${fileExtension}`;
      await saveFile(buffer, filename, mimeType);
      closeMessage();
      showMessage('success', 'Report downloaded successfully!', 4);
    } catch (e){
      closeMessage();
      showMessage('error', 'Download failed. Please try again.', 4);
      console.error(e);
    } finally {
      setIsFileSaving(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Tooltip title='Export Transactions to Excel (.xlsx)'
             placement="bottom"
    >
      <Button
        disabled={isLoading || isFileSaving}
        type="outline"
        shape="round"
        onClick={onDownloadButtonClick}
        id="downloadButton"
        // loading={isLoading}
        style={{ width: "55px" }}
      >
        {/* <Space>
          <DownloadButtonIcon />
          <DownloadButtonLabel />
        </Space> */}
        <Space>
          {/* <DownloadOutlined />
          <span>Download xlsx</span> */}
          <DownloadButtonIcon />
        </Space>
      </Button>
      </Tooltip>
      {/* <Card
        bordered={false}
        headStyle={{
          borderBottom: "none",
        }}
        title={<Typography.Title level={4}>Downloads</Typography.Title>}
      >
        <Form className="report__form" layout="inline" autoComplete="off">
          <Col flex={1}>
                        <Form.Item>
                            <Select
                                className="report__form-select"
                                defaultValue="veridoc"
                                onChange={onServiceChange}
                                style={{ width: "100%" }}
                            >
                                <Select.Option value="veridoc">
                                    Document recognition
                                </Select.Option>
                                <Select.Option value="veriface">
                                    Face Recognition
                                </Select.Option>
                                <Select.Option value="verilive">
                                    Liveness detection
                                </Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col flex="none">
                        <Form.Item>
                            <Select
                                className="report__form-select"
                                defaultValue={fileDownloadParams.defaultFileExtension}
                                onChange={onFileExtensionChange}
                            >
                                <Select.Option value={"xlsx"}>
                                    .XLSX
                                </Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col flex="none">
                        <Form.Item>
                            <DatePicker
                                defaultValue={queryParams.defaultDateFrom}
                                picker="month"
                                disabledDate={disabledDate}
                                onChange={onDateChange}
                            />
                        </Form.Item>
                    </Col>
          <Col flex="none">
            <Button
              disabled={isLoading}
              type="outline"
              shape="round"
              onClick={onDownloadButtonClick}
              style={{ width: "128px" }}
            >
              <Space>
                <DownloadButtonIcon />
                <DownloadButtonLabel />
              </Space>
            </Button>
          </Col>
        </Form>
      </Card> */}
    </>
  );
}
